import { render } from "./button-reviews.vue?vue&type=template&id=776a5f14&scoped=true"
import script from "./button-reviews.vue?vue&type=script&lang=js"
export * from "./button-reviews.vue?vue&type=script&lang=js"

import "./button-reviews.vue?vue&type=style&index=0&id=776a5f14&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-776a5f14"]])

export default __exports__